/**
 * Search a session storage in the document
 * @param {string} name session storage name
 * @returns {string|null} session storage value or null
 */
export const getSessionStorage = (name: string): string | null => {
  return typeof window !== 'undefined' ? sessionStorage.getItem(name) : null;
};

/**
 * Remove a session storage from the document
 * @param {string} name session storage Name
 */
export const removeSessionStorage = (name: string) => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(name);
  }
};

/**
 * Set a session storage in the document
 * @param {string} name session storage name
 * @param {string} value session storage value
 */
export const setSessionStorage = (name: string, value: string) => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(name, value);
  }
};